import { t } from '@lingui/core/macro';
import { BookingRecordListForCustomer } from '@navio/nsdk';
import { BadgeVariant, NoddiBadge } from 'noddi-ui-web';
import { getIsAwaitingCustomerPayment, getShouldPayForBooking } from 'noddi-util';

function getBookingStatus(booking: BookingRecordListForCustomer): { text: string; variant: BadgeVariant } {
  const shouldPayForBooking = getShouldPayForBooking(booking.order);

  if (booking.isCancelled) {
    return { text: t`Cancelled`, variant: 'destructive' };
  }

  if (booking.isFullyUnableToComplete) {
    return { text: t`Unable to complete`, variant: 'destructive' };
  }

  if (booking.isPartiallyUnableToComplete) {
    return { text: t`Partially completed`, variant: 'warning' };
  }

  if (booking.completedAt) {
    if (!shouldPayForBooking) {
      return { text: t`Completed`, variant: 'success' };
    }
    if (booking.order.isFullyPaid) {
      return { text: t`Paid`, variant: 'success' };
    } else if (booking.order.isManuallyInvoiced) {
      return { text: t`Completed & Invoiced`, variant: 'warning' };
    } else if (booking.order.amountPaid.amount > 0) {
      return { text: t`Partially paid`, variant: 'warning' };
    } else {
      return { text: t`Unpaid`, variant: 'warning' };
    }
  }

  if (booking.startedAt) {
    return { text: t`Service in progress`, variant: 'outline' };
  }

  if (getIsAwaitingCustomerPayment(booking.status.value)) {
    return { text: t`Payment required`, variant: 'warning' };
  }

  return { text: t`Confirmed`, variant: 'default' };
}

interface BookingStatusChipProps {
  booking: BookingRecordListForCustomer;
}

export const BookingStatusChip = ({ booking }: BookingStatusChipProps) => {
  const { text, variant } = getBookingStatus(booking);

  return (
    <NoddiBadge variant={variant} className='w-fit'>
      {text}
    </NoddiBadge>
  );
};
